import { createFileRoute } from '@tanstack/react-router'

import { NavigateToNewFunnel } from '../../components/pages/subscription-v2/navigate-to-new-funnel.tsx'

export const Route = createFileRoute('/search')({
  component: NavigateToNewFunnel,
})
